export default "__VITE_ASSET__BGdJsME3__"